<template>
  <div style="height: 40px; ">
    <v-file-input
      outlined
      dense
      background-color="#ffffff"
      style="border-radius: 20px;"
      @change="uploadFile"
      :label="label"
    />
  </div>
</template>

<script>
import { url } from "../../util/Constants";
import Swal from "sweetalert";

export default {
  name: "InputUploadFile",
  props: {
    label: {
      type: String,
      required: false,
      default: "Upload file"
    }
  },
  data() {
    return {};
  },
  methods: {
    uploadFile(file) {
      if (file) {
        const formData = new FormData();
        // eslint-disable-next-line camelcase
        const file_name = file.name;
        formData.append("file_name", file_name);
        formData.append("file", file);
        this.$store
          .dispatch("Utility/getPathFile", formData)
          .then(path => {
            const fullPath = url + path;
            console.log({
              fullPath,
              path
            });
            this.$emit("update", { fullPath, path });
          })
          .catch(() => {
            Swal('','Failed to upload file','error');
          });
      }
    }
  }
};
</script>

<style scoped></style>
